import React from 'react';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import type { Location } from '../../data/locations';

interface Props {
  map: google.maps.Map;
  locations: Location[];
  onMarkerClick: (location: Location) => void;
}

export default function MapCluster({ map, locations, onMarkerClick }: Props) {
  React.useEffect(() => {
    const markers = locations.map(location => {
      const marker = new google.maps.Marker({
        position: location.coordinates,
        map,
        title: location.name,
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 8,
          fillColor: "#a855f7",
          fillOpacity: 1,
          strokeColor: "#ffffff",
          strokeWeight: 2,
        }
      });

      marker.addListener('click', () => onMarkerClick(location));
      return marker;
    });

    new MarkerClusterer({
      map,
      markers,
      algorithm: new google.maps.MarkerClustererAlgorithm(),
      renderer: {
        render: ({ count, position }) => 
          new google.maps.Marker({
            position,
            icon: {
              path: google.maps.SymbolPath.CIRCLE,
              scale: 20,
              fillColor: "#a855f7",
              fillOpacity: 0.9,
              strokeColor: "#ffffff",
              strokeWeight: 2,
              labelOrigin: new google.maps.Point(0, 0)
            },
            label: {
              text: String(count),
              color: "#ffffff",
              fontSize: "12px",
              fontWeight: "bold"
            },
            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
          })
      }
    });

    return () => {
      markers.forEach(marker => marker.setMap(null));
    };
  }, [map, locations, onMarkerClick]);

  return null;
}